import "./SkeletonCard.css";

const SkeletonCard = () => {
  return <div className="skeleton-card"></div>;
};

export default SkeletonCard;